module.exports = __webpack_public_path__ + "img/vca2.a002f833.png";